"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Input", {
    enumerable: true,
    get: function() {
        return Input;
    }
});
var _react = _interop_require_wildcard(require("react"));
var _react1 = require("@chakra-ui/react");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var Input = (0, _react1.forwardRef)(function(_param, ref) {
    var LeadingIcon = _param.leadingIcon, TrailingIcon = _param.trailingIcon, leftLabel = _param.leftLabel, rightLabel = _param.rightLabel, props = _object_without_properties(_param, [
        "leadingIcon",
        "trailingIcon",
        "leftLabel",
        "rightLabel"
    ]);
    var _useState = _sliced_to_array((0, _react.useState)(false), 2), isFocused = _useState[0], setFocused = _useState[1];
    var _useState1 = _sliced_to_array((0, _react.useState)(false), 2), isHovered = _useState1[0], setHovered = _useState1[1];
    var _useState2 = _sliced_to_array((0, _react.useState)(false), 2), hasContent = _useState2[0], setHasContent = _useState2[1];
    var _useMultiStyleConfig = (0, _react1.useMultiStyleConfig)("Input", {
        variant: props.variant,
        size: props.size,
        isFocused: isFocused,
        isHovered: isHovered,
        isInvalid: props.isInvalid,
        isDisabled: props.isDisabled,
        hasContent: hasContent
    }), element = _useMultiStyleConfig.element, elementContainer = _useMultiStyleConfig.elementContainer, inputGroupStyles = _useMultiStyleConfig.inputGroup, _useMultiStyleConfig_field = _useMultiStyleConfig.field, fieldWithIconStyles = _useMultiStyleConfig_field.withIcon, leftLabelStyle = _useMultiStyleConfig.leftLabel, rightLabelStyle = _useMultiStyleConfig.rightLabel;
    var showLeadingIcon = LeadingIcon && !leftLabel;
    var showTrailingIcon = TrailingIcon && !rightLabel;
    return _react.default.createElement(_react1.InputGroup, _object_spread_props(_object_spread({}, inputGroupStyles), {
        "data-testid": "cmpsr.input-group"
    }), showLeadingIcon && _react.default.createElement(_react1.InputLeftElement, _object_spread_props(_object_spread({}, elementContainer), {
        pointerEvents: "none",
        children: (0, _react.cloneElement)(LeadingIcon, _object_spread({
            "data-testid": "cmpsr.input-icon",
            size: props.size === "l" ? "l" : "m"
        }, element))
    })), leftLabel && _react.default.createElement(_react1.InputLeftAddon, _object_spread_props(_object_spread({}, leftLabelStyle), {
        children: leftLabel
    })), _react.default.createElement(_react1.Input, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        ref: ref
    }, showLeadingIcon && _object_spread({}, fieldWithIconStyles)), {
        "data-testid": "cmpsr.input"
    }), props), {
        onFocus: function(evt) {
            var _props_onFocus, _props;
            (_props = props) === null || _props === void 0 ? void 0 : (_props_onFocus = _props.onFocus) === null || _props_onFocus === void 0 ? void 0 : _props_onFocus.call(_props, evt);
            setFocused(true);
        },
        onBlur: function(evt) {
            var _props_onBlur, _props;
            (_props = props) === null || _props === void 0 ? void 0 : (_props_onBlur = _props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(_props, evt);
            setFocused(false);
        },
        onMouseEnter: function(evt) {
            var _props_onMouseEnter, _props;
            (_props = props) === null || _props === void 0 ? void 0 : (_props_onMouseEnter = _props.onMouseEnter) === null || _props_onMouseEnter === void 0 ? void 0 : _props_onMouseEnter.call(_props, evt);
            setHovered(true);
        },
        onMouseLeave: function(evt) {
            var _props_onMouseLeave, _props;
            (_props = props) === null || _props === void 0 ? void 0 : (_props_onMouseLeave = _props.onMouseLeave) === null || _props_onMouseLeave === void 0 ? void 0 : _props_onMouseLeave.call(_props, evt);
            setHovered(false);
        },
        onChange: function(evt) {
            var _setHasContent, _props_onChange, _props;
            (_setHasContent = setHasContent) === null || _setHasContent === void 0 ? void 0 : _setHasContent(evt.target.value.length > 0);
            (_props = props) === null || _props === void 0 ? void 0 : (_props_onChange = _props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(_props, evt);
        }
    })), rightLabel && _react.default.createElement(_react1.InputRightAddon, _object_spread_props(_object_spread({}, rightLabelStyle), {
        children: rightLabel
    })), showTrailingIcon && _react.default.createElement(_react1.InputRightElement, _object_spread_props(_object_spread({}, elementContainer), {
        children: (0, _react.cloneElement)(TrailingIcon, _object_spread({
            size: props.size === "l" ? "l" : "m"
        }, element))
    })));
});
